var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 172,
    viewBox: "0 0 206 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.6726 158.444V170.169C53.6821 171.185 54.0282 171.721 54.6779 171.844C55.6784 172.043 57.1198 172.029 58.1014 171.934C59.2394 171.749 59.5713 171.199 59.5666 170.368V157.04L53.6773 158.444H53.6726Z",
    fill: "#996A52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M190.704 119.074V130.799C190.714 131.814 191.06 132.351 191.709 132.474C192.71 132.673 194.151 132.659 195.133 132.564C196.271 132.379 196.603 131.829 196.598 130.998V117.669L190.709 119.074H190.704Z",
    fill: "#996A52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.37842 143.478V155.203C6.3879 156.218 6.73405 156.754 7.38367 156.878C8.38417 157.077 9.82566 157.063 10.8072 156.968C11.9452 156.783 12.2771 156.233 12.2724 155.402V142.073L6.38316 143.478H6.37842Z",
    fill: "#996A52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.0291412 45.7674C-0.49245 35.11 6.00373 29.0458 18.2374 26.7445C57.3046 18.6352 95.7933 12.9838 133.376 11.1996C142.585 10.4404 147.658 11.6931 150.247 17.6292C155.368 28.111 158.09 41.81 159.887 56.7523C171.737 58.8306 185.303 62.3609 199.784 66.6647C202.847 67.3859 204.204 68.743 204.602 72.2923C205.963 84.3353 206.342 97.8398 205.674 116.507C205.422 119.985 205.048 122.357 203.265 122.936L197.641 124.811C194.867 125.541 193.222 124.853 193.625 121.594L65.9013 153.215V155.896C65.8018 157.139 65.3892 158.059 64.2939 158.306L54.9242 162.596L2.97376 144.104L0.0291412 45.7674Z",
    fill: "#EBB768"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.53651 85.1563C9.34684 70.1239 9.24252 55.5423 10.2051 46.3037C10.6366 41.5728 13.0833 39.001 18.3704 37.326C57.1388 27.3804 101.844 21.8998 150.651 19.5083C153.951 23.4847 158.105 43.134 159.887 56.7523L149.223 59.4522C148.422 59.7654 148.82 60.6148 149.579 60.8236L187.2 69.8819C191.254 71.1109 193.914 73.5973 193.625 78.7267V90.1148L56.2616 99.6287L9.53651 85.161V85.1563Z",
    fill: "#EFAC5B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.5618 94.2668L150.067 77.6543L193.625 90.1148L64.0285 117.669L59.5618 94.2668Z",
    fill: "#E29D54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3175 4.06522C60.6979 -2.38882 68.0619 -0.532259 70.958 5.26008C71.6386 6.62119 73.8164 8.52675 77.083 5.26008C79.8052 1.85737 91.3747 -4.94821 105.666 13.4268L105.54 13.223C114.406 24.745 119.19 41.6113 121.118 66.6012C122.77 88.0652 122.424 90.7927 117.276 96.8453C109.964 105.444 102.257 105.281 94.6701 96.3605L88.6022 89.2257L84.0267 96.3605C78.4216 105.097 68.1932 105.607 61.2926 97.4928C56.2622 91.5779 56.1239 91.5779 51.5696 97.4928C45.4884 105.394 35.8479 105.109 28.7983 96.8203C23.7227 90.8522 23.2891 87.8212 24.691 68.1527C26.6409 40.7956 37.2019 14.2769 50.165 4.18296C50.2156 4.14356 50.2665 4.10431 50.3175 4.06522Z",
    fill: "#FF9878"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 84.801,
    cy: 49.801,
    r: 29.801,
    fill: "url(#paint0_radial_19_309)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1451"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21406",
    x: 73,
    y: 22,
    width: 5.67638,
    height: 14.191,
    rx: 2.66442,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21407",
    x: 92.8677,
    y: 22.0001,
    width: 5.67638,
    height: 14.191,
    rx: 2.66442,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 85.7724,
    cy: 44.7057,
    rx: 4.25729,
    ry: 5.67638,
    fill: "black"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.53639 85.1564C8.91048 84.7531 9.70709 83.8183 11.3098 83.2821L20.4139 80.772C21.9123 80.4066 22.7469 80.5157 23.8185 80.772C38.9778 83.6807 51.9844 87.8848 62.2455 93.7355C64.5026 95.1827 64.9673 96.3263 65.1001 99.0927C65.7876 109.128 65.8066 133.343 65.9014 155.901C65.7354 157.087 65.2139 157.903 64.294 158.311L54.9243 162.601L53.0513 109.01C52.7431 104.303 50.8938 100.801 46.6263 99.1828L9.54113 85.1612L9.53639 85.1564Z",
    fill: "#FED079"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M47.5 99.5L22.5 90C23.6667 92 26 96.1 26 96.5C26 96.9 27.6667 100.333 28.5 102L35 105H43.5L49 102.5V100.5L47.5 99.5Z",
    fill: "#EBB768"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19_309",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.801 49.801) rotate(90) scale(29.801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.680d16824ed6729c965d20ddde63c385.svg";
export { ForwardRef as ReactComponent };